import { Component, OnInit } from '@angular/core';
import { RestaurantService } from 'src/app/shared/services/restaurant-services.';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit{

  isDropdownOpen:boolean=false;
  currentDate = new Date();
  selectedYear:any=this.currentDate.getFullYear();
  paymentDetails:any;
  years: any = [];


  constructor(
    private restoreService: RestaurantService
  ){}

  ngOnInit(): void {
    this.getPaymentDetails();
      this.getPaymentAmount();
    let startYear:any = 2023;

    while(this.selectedYear >= startYear) {

        this.years.push(this.selectedYear);

        if(this.selectedYear==startYear){

          return

        }

        this.selectedYear--

    }
  }

    toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

    selectYear(year: string) {
    this.selectedYear = year;
    this.isDropdownOpen = false; // Close the dropdown after selection

    // filter data based on year
    for(var i of this.paymentDetailsAllData){
      if(i?._id ==this.selectedYear){
        this.ordersList = i.orders
      }
    }
  }
  formatEventDate(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "Aug 17, 2025"
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }

  formatEventTime(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "3:30 PM"
    return d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }

  ordersList:any=[];
  paymentDetailsAllData:any=[];
  getPaymentDetails(){
    this.restoreService.getPaymentDetails().subscribe((res:any)=>{
        if(res.status ==200){
          this.selectedYear = new Date().getFullYear();
          this.paymentDetailsAllData = res.output;
          for(var i of res.output){
            if(i?._id ==this.selectedYear){
              this.ordersList = i.orders
            }
          }

          // let orders:any= res.output?.find(data => data?._id == this.selectYear);
          // this.ordersList = orders;

          // this.ordersList= res.output[0].orders;
        }
    })
  }


  getPaymentAmount(){
    this.restoreService.getPaymentAmount().subscribe((res:any)=>{
      if(res.status ==200){
          this.paymentDetails = res.output[0]
          console.log(this.paymentDetails,"payment details")
      }
    })
  }

  convertToDecimal(data:any){
    if(data){
      return data?.toFixed(2);
    }
    else{
      let data2 = 0;
      return data2?.toFixed(2);
    }
  }


  getData(res:any){
    return this.paymentDetails?.payments?.find(data => data?.paymentDone == res);
  }

}
